<template>
    <q-dialog persistent v-model="model">
        <q-card style="width: 500px; max-width: 80vw">
            <q-toolbar>
                <q-toolbar-title>Editar datos</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <div class="row">
                    <div class="col q-gutter-md">
                        <div class="row">
                            <div class="col">
                                <GltnInput
                                    v-model="empresaId"
                                    label="Empresa"
                                    readonly
                                    class="q-mr-md"
                                />
                            </div>
                            <div class="col">
                                <GltnInput
                                    v-model="clienteId"
                                    label="Cliente"
                                    readonly
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <GltnInput
                                    v-model="pedidoId"
                                    label="Pedido"
                                    readonly
                                    class="q-mr-md"
                                />
                            </div>
                            <div class="col">
                                <GltnInputFecha
                                    v-model="fecha"
                                    label="Fecha"
                                    fecha
                                    readonly
                                />
                            </div>
                        </div>
                        <div class="row">
                            <GltnInput
                                v-model="cantidad"
                                label="Cantidad Camiones"
                                class="col"
                            />
                        </div>
                        <div class="row">
                            <GltnInput
                                v-model="tipo"
                                label="Tipo Camiones"
                                class="col"
                            />
                        </div>
                        <div class="row">
                            <GltnInput
                                v-model="carroceria"
                                label="Carrocería"
                                class="col"
                            />
                        </div>
                        <div class="row">
                            <GltnInputFecha
                                v-model="fechaDisponibilidad"
                                label="Fecha de disponibilidad"
                                class="col"
                            />
                        </div>
                        <div class="row">
                            <GltnInput
                                v-model="observaciones"
                                label="Observaciones"
                                class="col"
                            />
                        </div>
                    </div>
                </div>
            </q-card-section>
            <q-card-actions align="right" class="text-primary">
                <q-btn flat label="Cancelar" v-close-popup />
                <q-btn
                    flat
                    label="Guardar"
                    @click="dataUpdate"
                    :loading="loading"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup>
import GltnInput from "@/components/form/GltnInput.vue";
import GltnInputFecha from "@/components/form/GltnInputFecha.vue";
import AgendamientoService from "@/services/AgendamientoService.js";
import { ref } from "vue";
import { useQuasar } from "quasar";
import TotvsLogisticaService from "@/services/TotvsLogisticaService.js";
import { format, parse } from "date-fns";
const $q = useQuasar();
const emit = defineEmits(["dataUpdate"]);
const tipo = defineModel("tipo");
const carroceria = defineModel("carroceria");
const cantidad = defineModel("cantidad");
const observaciones = defineModel("observaciones");
const empresaId = defineModel("empresa");
const clienteId = defineModel("cliente");
const pedidoId = defineModel("pedido");
const fecha = defineModel("fecha");
const depositoId = defineModel("deposito");
const fechaDisponibilidad = defineModel("fechaDisponibilidad", {
    type: String,
    default: () => {
        return format(new Date(), "dd-MM-yyyy");
    },
});
const row = defineModel("row");

const model = defineModel({ default: false });
const loading = ref(false);
const props = defineProps({
    id: {
        type: Number,
        required: true,
    },
});
const dataUpdate = async () => {
    loading.value = true;
    try {
        const total = await TotvsLogisticaService.getTotalAgendaByPedido({
            pedido: pedidoId.value,
            transportadoraId: row.value.IDTRANSP,
            unidadeId: row.value.IDLOG,
        });

        if (parseInt(cantidad.value) < parseInt(total)) {
            $q.notify({
                color: "negative",
                message:
                    "No puede asignarse una cantidad menor a la ya agendada",
            });
            return;
        }
        const fechaDisponibilidadFormatted = format(
            parse(fechaDisponibilidad.value, "dd-MM-yyyy", new Date()),
            "yyyyMMdd"
        );
        AgendamientoService.store({
            camiones_cant: cantidad.value,
            camiones_tipo: tipo.value,
            carroceria: carroceria.value,
            observaciones: observaciones.value,
            empresa_id: empresaId.value,
            cliente_id: clienteId.value,
            pedido_id: pedidoId.value,
            deposito_id: depositoId.value,
            fecha: fecha.value,
            fecha_disponibilidad: fechaDisponibilidadFormatted,
        });
        $q.notify({
            color: "positive",
            message: "Datos guardados correctamente",
        });
        emit("dataUpdate");
    } catch (error) {
        console.error(error);
        $q.notify({
            color: "negative",
            message: "Error al guardar los datos",
        });
    } finally {
        loading.value = false;
        model.value = false;
    }
};
</script>
